import { useEffect } from "react";
import Lenis from "lenis";

/**
 * Smooth scroll provider using Lenis. Mount once at app root.
 */
export default function useLenis() {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.15,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
        });

        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);

        // Anchor scrolling
        const onAnchorClick = (e) => {
            const target = e.target.closest('a[href^="#"]');
            if (!target) return;
            const id = target.getAttribute("href");
            if (!id || id === "#") return;
            const el = document.querySelector(id);
            if (el) {
                e.preventDefault();
                lenis.scrollTo(el, { offset: -80 });
            }
        };
        document.addEventListener("click", onAnchorClick);

        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            document.removeEventListener("click", onAnchorClick);
        };
    }, []);
}
